import { useEffect, useState } from "react";
import { IPagination } from "../../../types/pagination";
import { RegistroOcorrencia } from "../../../services/RegistroOcorrencia";
import { IGetRegistroOcorrenciaParams, IRegistroOcorrenciaDTO } from "../../../types/registroOcorrencia";
import { toast } from "react-toastify";
import { useMediaQuery } from "react-responsive";
import { useContextSite } from "../../../context/Context";
import { useSearchParams } from "react-router-dom";
import { IArquivoDTO } from "../../../types/arquivo";

export const useIncidentHistorySchedule = () => {
    const [pagination, setPagination] = useState<IPagination>({} as IPagination);
    const [numberPage, setNumberPage] = useState(0);
    const [events, setEvents] = useState<IRegistroOcorrenciaDTO[]>([]);
    const isMobile = useMediaQuery({ maxWidth: "640px" });
    const { setIsLoad } = useContextSite();
    const [searchParams, setSearchParams] = useSearchParams();
    let uuidAgendamento = searchParams.get("id");

    function getEvents(props: IGetRegistroOcorrenciaParams) {
        setIsLoad(true);
        RegistroOcorrencia.listar({ ...props, size: 5 })
        .then(({ data }) => {
            setEvents(data.content);
            setPagination({
            actualPage: data.number,
            totalPage: data.totalPages,
            totalRegister: data.totalElements,
            });
        })
        .catch(
            ({
            response: {
                data: { mensagem },
            },
            }) => toast.error(mensagem)
        )
        .finally(() => {
            setIsLoad(false);
        });
    }

    useEffect(() => {
        if (uuidAgendamento) {
        getEvents({
            uuidAgendamento,
            page: numberPage,
        });
        }
    }, [numberPage, uuidAgendamento]);

    async function handleDownloadFile(file: IArquivoDTO): Promise<void> {
        if (!file.uuid || typeof file.uuid !== "string") {
            throw new Error("UUID inválido ou não fornecido.");
        }

        const baseUrl = process.env.REACT_APP_BRAVE_API_URL;
        if (!baseUrl) {
            throw new Error("URL da API não configurada.");
        }

        let token = "";

        if (typeof window !== "undefined") {
            const localToken = localStorage.getItem("@token");
            if (localToken) {
                token = localToken.replaceAll('"', "");
            }
        }

        const url = `${baseUrl}/arquivo/${file.uuid}/download`;

        try {
            const response = await fetch(url, {
                method: "GET",
                headers: token ? { Authorization: `Bearer ${token}` } : undefined,
            });

            if (!response.ok) {
                throw new Error(
                `Erro ao baixar arquivo: ${response.status} ${response.statusText}`
                );
            }

            const blob = await response.blob();

            const filename = file.fileName || "arquivo-download";

            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = decodeURIComponent(filename);
            link.style.display = "none";
            document.body.appendChild(link);
            link.click();
            URL.revokeObjectURL(link.href);
            document.body.removeChild(link);
        } catch (error) {
            console.error("Erro no download do arquivo:", error);
            throw error;
        }
    }

    return { pagination, setNumberPage, events, isMobile, handleDownloadFile };
};
